export default "__VITE_ASSET__DgPfMlGW__"